import Js from "../images/js.webp";
import Css from "../images/css.webp";
import Scss from "../images/scss.webp";
import Html from "../images/html.webp";
import MySQL from "../images/mysql.webp";
import React from "../images/react.webp";
import Next from "../images/nextjs.webp";
import Ts from "../images/typescript.webp";
import Node from "../images/node-logo.webp";
import Express from "../images/expressjs.webp"
import Tailwind from "../images/tailwind.webp";
import Redux from "../images/redux.webp";
import GitHub from "../images/github-logo.webp";
import Wordpress from "../images/wordpress.webp";

export const imageMap = [
  {
    image: Js,
    text: "JavaScript",
    borderRadius: "none",
  },
  {
    image: React,
    text: "React JS",
    borderRadius: "none",
  },
  {
    image: Next,
    text: "Next JS",
    borderRadius: "none",
  },
  {
    image: Node,
    text: "Node JS",
    borderRadius: "none",
  },
  {
    image: Express,
    text: "Express JS",
    borderRadius: "100%",
  },
  {
    image: Ts,
    text: "TypeScript",
    borderRadius: "none",
  },
  {
    image: GitHub,
    text: "GitHub",
    borderRadius: "none",
  },
  {
    image: Html,
    text: "HTML",
    borderRadius: "none",
  },
  { 
    image: Css, 
    text: "CSS", 
    borderRadius: "none",
  },
  {
    image: Scss,
    text: "SASS",
    borderRadius: "none",
  },
  {
    image: Tailwind,
    text: "Tailwind CSS",
    borderRadius: "100%",
  },
  {
    image: Redux,
    text: "Redux",
    borderRadius: "100%",
  },
  {
    image: MySQL,
    text: "MySQL",
    borderRadius: "none",
  },
/*   {
    image: Supabase,
    text: "Supabase",
    borderRadius: "none"
  }, */
  {
    image: Wordpress,
    text: "Wordpress",
    borderRadius: "100%",
  },
];
